/*
	This loads the products lower on the page after the scroll down
*/

if (Luna.template.name === "product") {
	const productRecommendationsSection = document.querySelector(
		'[data-component="product-recommendations"]',
	);

	const relatedProductsContent = document.querySelector(
		'[data-content="related-products"]',
	);

	if (productRecommendationsSection && relatedProductsContent) {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;

			observer.unobserve(productRecommendationsSection);

			const url = productRecommendationsSection.dataset.url;

			fetch(url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;

					const recommendations = html.querySelector(
						'[data-content="related-products"]',
					);

					if (recommendations && recommendations.innerHTML.trim().length) {
						relatedProductsContent.innerHTML = recommendations.innerHTML;
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		const observer = new IntersectionObserver(handleIntersection, {
			rootMargin: "0px 0px 200px 0px",
		});

		observer.observe(productRecommendationsSection);
	}
}
